import React from 'react'

function AdminExercise() {
  return (
    <div>AdminExercise</div>
  )
}

export default AdminExercise;